// ブラウザに情報を記録するクラス
export default class Store {
  get(key) {
    return this._decode(localStorage.getItem(key));
  }

  set(key, val) {
    localStorage.setItem(key, this._encode(val));
  }

  remove(key) {
    localStorage.removeItem(key);
  }

  allClear() {
    localStorage.clear();
  }

  _encode(val) {
    if (val && val != "") {
      return btoa(unescape(encodeURIComponent(val)));
    }
    return "";
  }

  _decode(val) {
    if (val && val != "") {
      return decodeURIComponent(escape(atob(val)));
    }
    return "";
  }
}
